import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { Dropdown } from "@circle-react-shared/uikit/Dropdown";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";
import { useDeleteCustomThemeModal } from "./DeleteCustomThemeModal";
import { useRenameCustomThemeModal } from "./RenameCustomThemeModal";

export const SavedCustomThemeDropdownOptions = () => {
  const { show: showRenameCustomThemeModal } = useRenameCustomThemeModal();
  const { show: showDeleteCustomThemeModal } = useDeleteCustomThemeModal();
  const { currentCanvasTheme, toggleCurrentCanvasTheme, appearance } =
    useBuilderStore(state => ({
      currentCanvasTheme: state.currentCanvasTheme,
      toggleCurrentCanvasTheme: state.toggleCurrentCanvasTheme,
      appearance: state.appearance,
    }));
  const { reset } = useFormContext();

  return (
    <Dropdown
      size="small"
      button={
        <IconButton
          name="16-menu-dots-horizontal"
          iconSize={16}
          buttonSize={20}
          ariaLabel={t(
            "settings.site.pages.actions.saved_custom_theme_actions.aria_label",
          )}
        />
      }
    >
      <Dropdown.ItemWithLink
        onClick={() =>
          showRenameCustomThemeModal({
            currentCanvasTheme,
            toggleCurrentCanvasTheme,
          })
        }
      >
        {t(
          "settings.site.pages.actions.saved_custom_theme_actions.actions.rename",
        )}
      </Dropdown.ItemWithLink>
      <Dropdown.Separator />
      <Dropdown.ItemWithLink
        onClick={() =>
          showDeleteCustomThemeModal({
            currentCanvasTheme,
            toggleCurrentCanvasTheme,
            appearance,
            reset,
          })
        }
      >
        <span className="text-v2-danger">
          {t(
            "settings.site.pages.actions.saved_custom_theme_actions.actions.delete",
          )}
        </span>
      </Dropdown.ItemWithLink>
    </Dropdown>
  );
};
